import { useState } from 'react';

import {
  TextInput,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

import * as S from './styled'

type CouponStatus = 'valid' | 'invalid' | 'expired' | 'used';
export interface CouponState {
  value: string,
  loading?: boolean,
  status?: CouponStatus,
}
interface Props {
  coupon?: string
  buttonText?: string
  couponState: CouponState
  onSubmit: { (coupon: string): void }
}

const CouponForm = ({
  couponState = {
    value: '',
  },
  buttonText = 'Apply Code',
  onSubmit,
}: Props) => {
  const [coupon, setCoupon] = useState(couponState.value)
  return (
    <Flex
      shrink={0}
      width="100%"
    >
      <Flex fillSpace spacing={15}>
        <S.FieldWrapper couponStatus={couponState.status}>
          <Text color="#333333" weight="700">Coupon</Text>
          <TextInput
            value={coupon}
            onChange={(e: any) => {
              setCoupon(e.target.value || '')
            }}
            placeholder="Coupon Code"
          />

          {couponState.status === 'invalid' && (
            <span className="error-msg">Invalid Code</span>
          )}
        </S.FieldWrapper>
        <S.Submit
          ghost={!coupon || couponState.status === 'valid'}
          isDisabled={!coupon || couponState.loading}
          isLoading={couponState.loading}
          onClick={() => {
            onSubmit(coupon)
          }}
        >
          {couponState.status == 'valid' ? 'Accepted!' : buttonText}
        </S.Submit>
      </Flex>
    </Flex>
  )
}

export default CouponForm;
